module.exports = __webpack_public_path__ + "img/calendar2-month.a412e969.svg";